import axios from 'axios';
import { setToken } from './api';
import TokenService from './tokenService';

export function resolveTransformer(response) {
    return Promise.resolve(response && response.data);
}

const normalizeErrorPayload = (data) => {
    if (data && typeof data === 'object') {
        if (!data.message && typeof data.error === 'string') {
            data.message = data.error;
        }
    }
    return data;
};

const isAuthEndpoint = (url = '') =>
    /\/account\/(login|signup|refreshToken|forgot|confirmate)/.test(url);

export function rejectTransformer(error) {
    if (!error.response) {
        return Promise.reject(error);
    }
    const { config } = error.response;
    if (
        error.response.status === 401 &&
        !isAuthEndpoint(config?.url) &&
        !(config && config._retried) &&
        TokenService.getRefreshToken()
    ) {
        return TokenService.getNewToken()
            .then(token => {
                if (!token) {
                    return Promise.reject(normalizeErrorPayload(error.response.data));
                }
                setToken(token);
                const configWithToken = {
                    ...config,
                    _retried: true,
                    headers: {
                        ...config.headers,
                        Authorization: `Bearer ${token}`,
                    },
                };
                return axios.request(configWithToken).then(({ data }) => data);
            })
            .catch(() => Promise.reject(normalizeErrorPayload(error.response.data)));
    }
    return Promise.reject(normalizeErrorPayload(error.response.data));
}
